import { QUERY_KEYS } from '@forwardflow/helpers/utils'
import { PhoneNumberManagementService } from '../services/phone-number-management.service'
import PhoneNumberService from '@forwardflow/services/PhoneNumberService'
import useSWR, { useSWRConfig } from 'swr'
import { PaginationQueryParams } from '@forwardflow/types'

export const useGetPhoneNumbers = () => {
   return useSWR([QUERY_KEYS.GET_PHONE_NUMBERS], () =>
      PhoneNumberManagementService.getPhoneNumbers()
   )
}

export const useGetAvailablePhoneNumbers = (
   queryParams: PaginationQueryParams
) => {
   return useSWR(
      queryParams ? [QUERY_KEYS.GET_PHONE_NUMBERS, 'available', queryParams] : null,
      () => PhoneNumberService.getAvailablePhoneNumbers(queryParams)
   )
}

export const useAssignPhoneNumberToCampaign = () => {
   const { mutate } = useSWRConfig()

   const assignPhoneNumber = async (
      phoneNumbers: string[],
      campaignId: string
   ) => {
      const result =
         await PhoneNumberManagementService.assignPhoneNumberToCampaign(
            phoneNumbers,
            campaignId
         )
      // Revalidate the phone numbers list
      mutate([QUERY_KEYS.GET_PHONE_NUMBERS])
      return result
   }

   return { assignPhoneNumber }
}

export const useRemovePhoneNumbers = () => {
   const { mutate } = useSWRConfig()

   const removePhoneNumbers = async (phoneNumbers: string[]) => {
      const result = await PhoneNumberManagementService.removePhoneNumbers(
         phoneNumbers
      )
      // Revalidate the phone numbers list
      mutate([QUERY_KEYS.GET_PHONE_NUMBERS])
      return result
   }

   return { removePhoneNumbers }
}

export const useUpdateRealtorNumber = () => {
   const { mutate } = useSWRConfig()

   const updateRealtorNumber = async (phoneNumber: string) => {
      const result = await PhoneNumberManagementService.updateRealtorNumber(
         phoneNumber
      )
      // Revalidate the phone numbers list
      mutate([QUERY_KEYS.GET_PHONE_NUMBERS])
      return result
   }

   return { updateRealtorNumber }
}

export const useGetPhoneNumberPricing = (totalNumbers: number) => {
   return useSWR(
      totalNumbers > 0
         ? [QUERY_KEYS.GET_PHONE_NUMBERS, 'pricing', totalNumbers]
         : null,
      () => PhoneNumberManagementService.getPhoneNumberPricing(totalNumbers)
   )
}

export const usePurchasePhoneNumbers = () => {
   const { mutate } = useSWRConfig()

   const purchasePhoneNumbers = async (orgId: string, phoneNumbers: string[]) => {
      const result = await PhoneNumberManagementService.purchasePhoneNumbers(
         orgId,
         phoneNumbers
      )
      // Revalidate both the phone numbers list and available numbers
      mutate([QUERY_KEYS.GET_PHONE_NUMBERS])
      mutate((key) => {
         return (
            Array.isArray(key) &&
            key[0] === QUERY_KEYS.GET_PHONE_NUMBERS &&
            key[1] === 'available'
         )
      })
      return result
   }

   return { purchasePhoneNumbers }
}
